import React from "react";

/**
 * قائمة الخدمات + المنصات جواها.
 * مستخدمة في:
 *  - Sidebar.jsx (ديسكتوب)
 *  - Dashboard.jsx (السايدبار بتاع الموبايل)
 * عشان منكررش نفس الـ JSX في المكانين.
 */
const ServicesList = ({
  services,
  platforms,
  activePlatforms,
  onSelect,
  toggleAll,
  showAllButton = true,
}) => (
  <>
    {showAllButton && (
      <button
        className={`sidebar-btn ${
          activePlatforms.length === platforms.length ? "active" : ""
        }`}
        onClick={toggleAll}
      >
        👑 الكل
      </button>
    )}

    {services.map((service) => (
      <div key={service.id} className="service-group">
        <h4 className="service-title">{service.name}</h4>

        {service.platforms.length > 0 ? (
          <div className="service-platforms">
            {service.platforms.map((p) => (
              <button
                key={p.id}
                className={`platform-item ${
                  activePlatforms.includes(p.id) ? "active" : ""
                }`}
                onClick={() => onSelect(p.id)}
              >
                <img src={p.logo} className="platform-logo" alt={p.name} />
                <span>{p.name}</span>
              </button>
            ))}
          </div>
        ) : (
          <p className="empty-service">هذه الخدمة غير متاحة حالياً</p>
        )}
      </div>
    ))}
  </>
);

export default ServicesList;
